if (!customElements.get('annais-ritual-videos')) {
  customElements.define('annais-ritual-videos', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const track = this.querySelector('.ap-ritual-track');
      const slides = [...this.querySelectorAll('.ap-ritual-slide')];
      const videos = slides.map(slide => slide.querySelector('video'));
      const nav = this.querySelector('.ap-ritual-navigation');
      let active = 0;
      const update = () => {
        const left = track.getBoundingClientRect().left;
        active = slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? index : best, 0);
        videos.forEach((video, index) => { if (index !== active) video.pause(); });
        nav.querySelector('[data-position]').textContent = `${active + 1} / ${slides.length}`;
        nav.querySelector('[data-previous]').disabled = active === 0;
        nav.querySelector('[data-next]').disabled = active === slides.length - 1;
      };
      slides.forEach((slide, index) => {
        const button = slide.querySelector('[data-play]');
        const video = videos[index];
        button.hidden = false;
        button.addEventListener('click', () => video.play().catch(() => { video.controls = true; }), options);
        video.addEventListener('play', () => { button.hidden = true; videos.forEach(other => { if (other !== video) other.pause(); }); }, options);
        video.addEventListener('pause', () => { button.hidden = false; }, options);
      });
      if (slides.length > 1) {
        nav.hidden = false;
        const move = direction => track.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, active + direction)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        nav.querySelector('[data-previous]').addEventListener('click', () => move(-1), options);
        nav.querySelector('[data-next]').addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, options);
        update();
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.querySelectorAll('video').forEach(video => video.pause()); }
  });
}
